import React from 'react';
import './style.css';

function App(props) {
  return (
      <>
        <a target="_top" href={props.mailTo}><i className={props.iconName}></i>{props.textReport}</a>
      </>
  );
}

export default App;